import { withClasses } from "@xo-union/react-css-modules";
import styles from "../../css/styles.css";
import DatePicker from "./component.js";
export default withClasses(styles)(DatePicker);